import { useEffect, useState } from "react";


export function MusicPlayer({ audioSRC }) {
    const [isPlaying, setIsPlaying] = useState(false);
    const [areVocalsIsolated, setAreVocalsIsolated] = useState(false);
    const [audio, setAudio] = useState(null);
  
    useEffect(() => {
      const newAudio = new Audio(audioSRC);
      newAudio.addEventListener("ended", () => setIsPlaying(false));
      setAudio(newAudio);
      return () => {
        newAudio.removeEventListener("ended", () => setIsPlaying(false));
        newAudio.pause();
      };
    }, []);
  
    // when audioSRC changes, we need to update the audio
    useEffect(() => {
      if (audio) {
        audio.src = audioSRC;
      }
    }, [audioSRC]);
  
    const handlePlay = () => {
      if (isPlaying) {
        audio.pause();
        setIsPlaying(false);
      } else {
        audio.play();
        setIsPlaying(true);
      }
    };
  
    return (
      <div className="flex flex-col justify-center items-center w-full">
        <div
          className="w-full h-[200px] bg-white flex justify-center items-center
          cursor-pointer
          "
          onClick={handlePlay}
        >
          {/* boxy shadow button */}
          <div
            className={`w-full h-[200px] flex justify-center items-center 
            transition-all group bg-[#3F52FF]
            outline-dashed outline-[4px]
            `} 
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="white"
              className="w-24 h-24
              group-active:scale-75 transition-all
              "
              viewBox="0 0 16 16"
            >
              {!isPlaying ? (
                <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z" />
              ) : (
                <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z" />
              )}
            </svg>
          </div>
        </div>
        <div className="flex justify-center items-center mt-4 w-full  cursor-pointer">
          {/* <div
            className={
              `boxy-shadow font-bold font-SF` +
              (areVocalsIsolated ? "bg-yellow-400" : "bg-[#3F52FF]")
            }
          >
            <h2 className=" w-full">Isolate Vocals</h2> 
          </div> */}
          <div
            className="boxy-shadow bg-gray-200 w-full cursor-pointer flex
            justify-center items-center gap-2
            "
            onClick={() => {
              const downloadLink = document.createElement("a");
              downloadLink.href = audioSRC;
              downloadLink.target = "_blank";
              downloadLink.referrerPolicy = "no-referrer";
              downloadLink.download = "vocals.wav";
              downloadLink.click();
            }}
          >
            <span>Download</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              className="bi bi-download"
              viewBox="0 0 16 16"
            >
              <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
              <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
            </svg>
          </div>
        </div>
      </div>
    );
  }
  